export const setMemberSearch = (value, page, limit, count) => {
  return {
    type: "SET_MEMBER_SEARCH",
    payload: { data: value, page, limit, count },
  };
};
